<template>
  <Modal :id="'cmp-free-dates'" @cancelled="onCancelClick">
    <template slot="header">{{ modalTitle }}</template>
    <div slot="subheader">{{ modalSubTitle }}</div>
    <template slot="body">
      <TaskContactRelations :contactRelations="contactRelations" />

      <div class="dt-grid-layout">
        <div id="" class="dt-grid-tab" style="">
          <div class="dt-grid-tab--body">
            <!-- <div class="dt-grid-row" style="margin-top: 20px">
              <div class="dt-grid-column" style="flex: 1 1 0%">
                <div
                  class="dt-grid-box hoverFC2"
                  style="--bw-bc: white; border-radius: 6px"
                >
                  <div class="dt-box-header">
                    <div class="dt-box-header--name">Type</div>
                  </div>
                  <div class="dt-box-body">
                    <TaskContactRelations :contactRelations="contactRelations" />
                  </div>
                </div>
              </div>
            </div> -->

            <div class="form-group" style="margin-top: 20px">
              <Dropdown
                :options="taskStatusTV"
                class="m2"
                :selected="taskStatusTV.find((e) => e.value == taskDetails.task.status)"
                :placeholder="$t('status')"
                v-on:selectedChange="(e) => onDropdownChange('status', e)"
                :listHeight="120"
                box
              ></Dropdown>
              <TextField
                :id="'notes'"
                class="m1"
                type="text"
                :textarea="true"
                :height="105"
                :value="taskDetails.task.notes"
                :placeholder="$t('notes')"
                @blur="(name, value) => onDropdownChange(name, { value })"
              />
              <Dropdown
                :options="usersTV"
                class="m2"
                :selected="assignedUserSelectedTV"
                :placeholder="$t('assigned_user')"
                v-on:selectedChange="(e) => onDropdownChange('assigned_users', e)"
                :listHeight="120"
                box
                multiple
              ></Dropdown>
            </div>
            <div class="dt-grid-row" style="margin-top: 20px">
              <div class="dt-grid-column" style="flex: 1 1 0%">
                <div
                  class="dt-grid-box hoverFC2"
                  style="--bw-bc: white; border-radius: 6px"
                >
                  <div class="dt-box-header">
                    <div class="dt-box-header--name">{{ $t("local_details") }}</div>
                  </div>
                  <div class="dt-box-body">
                    <TaskLocalDetailsRelation :localDetails="localDetails" />
                  </div>
                </div>
              </div>
            </div>
            <div class="dt-grid-row" style="margin-top: 20px" v-if="travelFlag">
              <div class="dt-grid-column" style="flex: 1 1 0%">
                <div
                  class="dt-grid-box hoverFC2"
                  style="--bw-bc: white; border-radius: 6px"
                >
                  <div class="dt-box-header">
                    <div class="dt-box-header--name">{{ $t("travel_before") }}</div>
                  </div>
                  <div class="dt-box-body">
                    <TaskTravelList :travels="travelsBefore" />
                  </div>
                </div>
              </div>
            </div>
            <div class="dt-grid-row" style="margin-top: 20px" v-if="travelFlag">
              <div class="dt-grid-column" style="flex: 1 1 0%">
                <div
                  class="dt-grid-box hoverFC2"
                  style="--bw-bc: white; border-radius: 6px"
                >
                  <div class="dt-box-header">
                    <div class="dt-box-header--name">{{ $t("travel_before") }}</div>
                  </div>
                  <div class="dt-box-body">
                    <TaskTravelList :travels="travelsAfter" type="after" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click="onCancelClick">{{$t('close')}}</button>
      <button class="dt-button v1 with-ico s6" @click.stop="onClickOK">
        <div class="button-text">
          {{ $t("ok") }}
        </div>
      </button>
    </template>
  </Modal>
</template>

<script>
import { BookingService } from "../services/booking-service";

import { createDTGridHost } from "../../../dt-plugins/dt-grid/dt-grid.mixin";
import { createTV } from "../../../models/text-value.model";
import TaskTravelList from "./tasks/task-travel-list";
import TaskLocalDetailsRelation from "./tasks/task-local-details-relation";
import TaskContactRelations from "./tasks/task-contact-relations";

export default {
  components: {
    TaskTravelList,
    TaskLocalDetailsRelation,
    TaskContactRelations,
  },
  props: {},
  data: function () {
    return {
      taskDetails: { task: {}, cdate: {} },
    };
  },
  mixins: [createDTGridHost()],
  mounted: async function () {
    this.loadTaskDetails();
  },
  watch: {},
  computed: {
    taskIdR: function () {
      return this.$route.query.task_id;
    },
    travelsBefore() {
      return (this.taskDetails?.task_travels || []).filter((r) => r.after_gig_flag != 1);
    },
    travelsAfter() {
      return (this.taskDetails?.task_travels || []).filter((r) => r.after_gig_flag == 1);
    },
    localDetails() {
      return this.taskDetails?.task_local_details || [];
    },
    contactRelations() {
      return this.taskDetails?.task_contact_relations || [];
    },
    travelFlag() {
      return this.taskDetails?.travel_flag && this.taskDetails.travel_flag == 1
        ? true
        : false;
    },
    modalTitle() {
      const { task, sentUser } = this.taskDetails;
      return task.task ? `${task?.task || ""} (due by ${task?.due_date || ""}), sent by ${
        sentUser?.user_name || ""
      }` : "Task title";
    },
    modalSubTitle() {
      const { task, sentUser, cdate } = this.taskDetails;
      return cdate.start_date ? `${cdate.start_date || ""} ${this.artist.artist_name || ""},
      ${cdate.booking_location_name || ""} - ${cdate.city || ""}, ${
        cdate.country || ""
      } - 
      ${cdate.date_name || ""} - ${this.artist.booking_status_name || ""}` : "Task sub title";
    },
    artist() {
      const { task, calendarDateArtists } = this.taskDetails;

      let artist = {};
      if (task && task.artist_id) {
        artist = calendarDateArtists.find((r) => r.artist_id == task.artist_id) || {};
      }
      return artist;
    },
    usersTV: function () {
      return createTV(this.taskDetails?.users || [], "user_name", "user_id");
    },
    assignedUserSelectedTV() {
      const assignedUserArr = this.taskDetails?.task?.assigned_users
        ? this.taskDetails.task.assigned_users.split(",")
        : [];
      return (
        this.usersTV.filter((userTV) => assignedUserArr.includes("" + userTV.value)) || []
      );
    },
    taskStatusTV: function () {
      return createTV(
        (this.taskDetails?.task_statuses || []).map((r) => ({ text: r, value: r })),
        "text",
        "value"
      );
    },
  },
  methods: {
    async loadTaskDetails() {
      // console.log("mdsir: loadTaskDetails", this.taskIdR);
      const res = await BookingService.fetchBookingTaskDetails(this.taskIdR);
      // console.log("mdisr: res", res);
      this.taskDetails = res.data;
    },
    onCancelClick: function (event) {
      this.$emit("cancelled", true);
    },
    onDropdownChange(name, value) {
      let val = value.value;
      if (["assigned_users"].includes(name)) {
        val = value.map((r) => r.value).join();
      }
      this.taskDetails.task[name] = val;
      // BookingService.modifyTaskListItem({value: val, name, item: this.taskDetails.task});
      // console.log("mdsir: ", name, val);
      this.$emit("changed", { value: val, name, item: this.taskDetails.task });
    },
    onClickOK() {
      this.onCancelClick();
    },
  },
};
</script>

<style lang="scss">
.cmp-free-dates {
  .dt-ntable {
    border: 1px solid var(--sprt-5);
    border-radius: 6px;
    border-collapse: separate;
    /* border-bottom: none; */
    background: #f8f8f8;
    tbody {
      tr {
        &:last-child {
          border-bottom: none;
        }
      }
    }
    // tr {
    //   &.disabled {
    //     background: var(--bc-35);
    //   }
    // }
  }
}
</style>
